module.exports = __webpack_public_path__ + "img/IMG_4587.f00a9181.jpg";